module.exports = __webpack_public_path__ + "static/img/list-icon-birthday.bf58b37.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/vip/list-icon-birthday.png
// module id = Ow4f
// module chunks = 0 1 2 3 4 5 6